import styled from '@emotion/styled';
import { getPageOrientation } from '../../../../../../utils/getPageOrientation';

interface ThumbnailContainerProps {
  backgroundColor?: string;
  backgroundImage?: string;
  backgroundImageOpacity?: number;
  backgroundPosition?: string;
  isOrientedHorizontally?: boolean;
  isOrientedHorizontallySinglePage?: boolean;
}

export const ThumbnailContainer = styled.div<ThumbnailContainerProps>(
  {
    transition: 'opacity 0.3s ease',
    boxShadow: '0px 3px 10px 0px rgba(30, 50, 107, 0.9)',
    position: 'relative',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
  },
  props => {
    const { minHeight, width } = getPageOrientation(
      props.isOrientedHorizontally,
      props.isOrientedHorizontallySinglePage
    );
    return {
      minHeight,
      width,
      background: props.backgroundColor,
      '&::before': {
        content: '""',
        position: 'absolute',
        backgroundImage: `url(${props.backgroundImage})`,
        opacity: props.backgroundImageOpacity,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: props.backgroundPosition,
        backgroundSize: 'cover',
        inset: 0,
        zIndex: 0,
      },
    };
  }
);
